@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.linkshare

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.CreateShareResponseDto
import com.narbase.letsgo.web.models.linkshare.SharedLocationType

object CreateLinkShareEndpoint : EndPoint<CreateLinkShareEndpoint.Request, CreateLinkShareEndpoint.Response>() {
    class Request(
        @Suppress("NON_EXPORTABLE_TYPE") val sharedLocationType: DtoName<SharedLocationType>,
        val favoritePointId: KmmLong?,
        val lat: Double?,
        val lng: Double?,
        val address: String?,
        val name: String?,
        val addressDetails: String?,
        val os: String?,
        val osVersion: String?,
        val webVersion: String?,
        val deviceUuid: String?,
    )

    class Response(
        val share: CreateShareResponseDto,
    )
}
